module.exports = __webpack_public_path__ + "static/img/247.6b8430a.png";